// Computes the next set of channel ids the variant should be listed in when a
// single channel's "For sale" toggle flips. Adds (deduped) or removes one id.
export const getToggledChannelIds = (
  currentIds: string[],
  channelId: string,
  next: boolean,
): string[] =>
  next ? [...new Set([...currentIds, channelId])] : currentIds.filter(id => id !== channelId);
